import { render } from "./product-badge.vue?vue&type=template&id=031e3d7a"
import script from "./product-badge.vue?vue&type=script&lang=js"
export * from "./product-badge.vue?vue&type=script&lang=js"

import "./product-badge.vue?vue&type=style&index=0&id=031e3d7a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__